import { UploadFile } from "antd";
import { RcFile } from "antd/es/upload";
import { ClipboardEvent } from "react";
import uuid from "react-uuid";
import ImageUploaderStore from "../../stores/common/image-uploader";
import NewTaskStore from "../../stores/task/new-task";

const handleKeybordPhotoPaste = (event: ClipboardEvent<HTMLDivElement>, photoUploaderStore: ImageUploaderStore, 
    solutionUploaderStore: ImageUploaderStore, 
    callback?: () => any) => {

    if (event.clipboardData.files.length) {
        
        const ff = event.clipboardData.files[0];
        const file: UploadFile = {
            name: ff.name,
            size: ff.size,
            type: ff.type,
            uid: uuid(),
            originFileObj: ff as RcFile
        };

        photoUploaderStore.handleManualUpload(file, callback);
        solutionUploaderStore.handleManualUpload(file);
    }
};

export default handleKeybordPhotoPaste;